import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { CustomAction } from '@nimmsta/ng-commons-lib/data-table';
import {
  DataConnection,
  DataConnectionType,
  DataConnectionStatus,
} from '@nimmsta/ng-commons-lib/models';
import { Observable, of } from 'rxjs';

_('dataconnection.csv.execute');
_('dataconnection.execute');
_('dataconnection.sorting.upload');

export class ExecuteDataConnectionAction extends CustomAction<DataConnection> {
  override getText(item: DataConnection): string {
    switch (item.dataConnectionHandler) {
      case DataConnectionType.CSVDataConnection:
        return 'dataconnection.csv.execute';
      case DataConnectionType.SortingDataConnection:
        return 'dataconnection.sorting.upload';
      default:
        return this._text;
    }
  }

  override isEnabled(item: DataConnection): Observable<boolean> {
    return of(
      item.dataConnectionHandler === DataConnectionType.CSVDataConnection ||
        (item.dataConnectionHandler ===
          DataConnectionType.SortingDataConnection &&
          item.status === DataConnectionStatus.ACTIVE),
    );
  }
}
